import React from 'react';


function ClipModalInfo(props) {
    return (
      <div>
        <div className="flex justify-center">
          <div className="w-24 h-12 border-2 border-zinc-700 flex justify-center items-center text-white px-4">
            {props.startTime}
          </div>
          <div className="h-12 flex justify-center items-center text-white text-xl px-4">
            -
          </div>
          <div className="w-24 h-12 border-2 border-zinc-700 flex justify-center items-center text-white px-4">
            {props.endTime}
          </div>
        </div>
      </div>
    );
}

export default ClipModalInfo;
